import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getVoucherDetails } from "../../../../redux/slices/voucherSlice";

const VoucherDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { voucherDetails, refetch } = useSelector(
    (state) => state.voucherSlice
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    dispatch(getVoucherDetails(id, setIsLoading));
  }, [id]);

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div className="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <div>
          <div className="page-header">
            <h3 className="page-title">Voucher Details</h3>
          </div>
          <div className="row">
            <div className="col-8 mx-auto grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Enter new product details</h4> */}
                  <form className="form-sample">
                    <div className="row">
                      {/* Row 1 */}
                      <div className="col-6 mb-3">
                        <div class="form-group">
                          <label for="exampleInputUsername1">
                            Voucher Code :
                          </label>
                          <h6>{voucherDetails?.voucherCode}</h6>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div class="form-group">
                          <label for="exampleInputUsername1">
                            Voucher Access :
                          </label>
                          <h6>
                            {voucherDetails?.voucherAccess
                              ? voucherDetails.voucherAccess
                                  .charAt(0)
                                  .toUpperCase() +
                                voucherDetails.voucherAccess
                                  .slice(1)
                                  .toLowerCase()
                              : ""}
                          </h6>
                        </div>
                      </div>

                      {/* Row 2 */}
                      <div className="col-6 mb-3">
                        <div class="form-group">
                          <label for="exampleInputUsername1">
                            Voucher Parent :
                          </label>
                          <h6>
                            {voucherDetails?.user?.[0]?.fullName || "For All"}
                          </h6>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="discountType">
                            Discount Type :
                          </label>
                          <h6>
                            {voucherDetails?.discountType 
                              ? voucherDetails.discountType.charAt(0).toUpperCase() + 
                                voucherDetails.discountType.slice(1).toLowerCase()
                              : "Flat"}
                          </h6>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="discountPrice">
                            Discount {voucherDetails?.discountType === "percentage" ? "(%)" : "($)"} :
                          </label>
                          <h6>
                            {voucherDetails?.discountType === "percentage"
                              ? `${voucherDetails?.discountPrice}%`
                              : `$${voucherDetails?.discountPrice}`}
                          </h6>
                        </div>
                      </div>

                      {/* Row 3 */}
                      <div className="col-6 mb-3">
                        <div class="form-group">
                          <label for="exampleInputUsername1">
                            Voucher Status :
                          </label>
                          <h6>
                            {voucherDetails?.active ? "Active" : "Inactive"}
                          </h6>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="validDate">
                            Valid Date :
                          </label>
                          <h6>
                            {voucherDetails?.validDate
                              ? new Date(voucherDetails?.validDate)
                                  .toLocaleDateString("en-US", {
                                    month: "2-digit",
                                    day: "2-digit",
                                    year: "numeric",
                                  })
                                  .replace(/\//g, "-")
                              : "One Time"}
                          </h6>
                        </div>
                      </div>
                      
                      {/* Row 4 - Min Order Value and Max Discount */}
                      <div className="col-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="minOrderValue">
                            Minimum Order Value :
                          </label>
                          <h6>
                            {voucherDetails?.minOrderValue 
                              ? `$${voucherDetails.minOrderValue}` 
                              : "No minimum"}
                          </h6>
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="maxDiscountAvailable">
                            Maximum Discount Available :
                          </label>
                          <h6>
                            {voucherDetails?.maxDiscountAvailable 
                              ? `$${voucherDetails.maxDiscountAvailable}` 
                              : "No maximum"}
                          </h6>
                        </div>
                      </div>
                      
                      {/* Row 5 - Description */}
                      <div className="col-12 mb-3">
                        <div className="form-group">
                          <label htmlFor="description">
                            Description :
                          </label>
                          <p className="text-muted">
                            {voucherDetails?.description || "No description provided"}
                          </p>
                        </div>
                      </div>
                      
                      {/* Row 6 - Terms & Conditions */}
                      <div className="col-12 mb-3">
                        <div className="form-group">
                          <label htmlFor="condition">
                            Terms & Conditions :
                          </label>
                          <p className="text-muted">
                            {voucherDetails?.condition || "No terms and conditions specified"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VoucherDetails;
